module.exports = __webpack_public_path__ + "static/img/share.6bd9536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share.png
// module id = az9f
// module chunks = 1